import { graphql } from "@/graphql/codegen"

graphql(`
  query GetPayFile($input: PayFileGetInput!) {
    payFile {
      get(input: $input) {
        __typename
        ... on PayFileGetSuccess {
          payFile {
            payFileId
            status
            latestLog {
              payFileLogId
              event
              description
            }
          }
        }
        ... on PayFileGetFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
